const ThemesTypes = {
  TOGGLE_COLOR_THEME: "TOGGLE_COLOR_THEME",
};

export default ThemesTypes;
